// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"627":"92a87a78","704":"46f7b66e","747":"3e9724a7","848":"452b26c6","859":"f15e4014","895":"1033a2f9"}[chunkId] + ".css";
};